import { createSelector } from 'reselect';

const encargosCreadorSelector = state => state.encargosCreador;

export const sePuedeGuardar = createSelector(
  [encargosCreadorSelector],
  (workspace) => {
    const { encargos } = workspace;
    for (let i = 0; i < encargos.length; i++) {
      const encargo = encargos[i];
      const { cabecera: { cliente } } = encargo;
      if (cliente === null || cliente === undefined) {
        return false;
      }
      const { id: pacienteId } = cliente;
      if (pacienteId === null) return false;
    }
    return true;
  },
);

export const calcularTotalPorEncargo = createSelector(
  [encargosCreadorSelector],
  (workspace) => {
    const output = [];
    const { encargos } = workspace;
    encargos.forEach((encargo) => {
      let precio = 0;
      const { uuid, detalles, nombre } = encargo;
      detalles.forEach((detalle) => {
        const { precio: precioDetalle, unidades } = detalle;
        if (precioDetalle) {
          precio += (parseFloat(precioDetalle) * unidades);
        }
      });
      output.push({
        uuid,
        precio,
        nombre,
      });
    });
    return output;
  },
);

export const calcularTotal = createSelector(
  [calcularTotalPorEncargo],
  (encargos) => {
    let output = 0;
    encargos.forEach(({ precio }) => {
      output += precio;
    });
    return output;
  },
);
